import React from 'react';

const CreditHoldBanner = (props) => {
    return (
      <div className = "credit-hold-banner">
        Your account is on credit hold. <a href='https://www.sami.com.au/contact-us/' target="_blank" rel="noopener noreferrer">Contact SAMI.</a>
      </div>
    )
  }

export default CreditHoldBanner;
